import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

/**
 * Fetches Healthlink messages for a specific type ("lab" | "radiology").
 * Side effect on the BE: this endpoint auto-downloads the XSL stylesheet
 * for the message type from Healthlink, so its results carry a usable xsl.
 * Used as a temporary XSL source until queryMessages returns it directly.
 */
export const useHealthlinkMessagesByType = (messageType, { enabled = true } = {}) => {

  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["healthlinkMessagesByType", messageType, tenantVal],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/healthlink/messages/${messageType}?page=1&size=10&sortBy=DESC`
      );

      return response.data;
    },
    enabled: !!messageType && !!tenantVal && enabled,
    meta: { errorMessage: "Error fetching Healthlink messages" },
  });
};
